export interface Assets {
  _id: string;
  name: string;
  assetType: string;
  emissionGroup: string;
  organization: number;
  assetStatus: string;
  suborganizationName: string;
  siteName: string;
  // true once deleted; a kept one stays listed, its records untouched
  isDelete?: boolean;
}

// what a new record may be put on: not deleted, and not left deactivated by an older delete
export const isPickableAsset = (asset: Assets) =>
  asset.assetStatus !== "deactivated" && asset.isDelete !== true;

export const assetsTypeList = [
  "fuel",
  "energy",
  "wastewater",
  "refrigerants",
  "waste-disposal",
  "septic-tank",
  "fertilizer",
  "business-travel",
  "employee-commuting",
  "fire-extinguishing",
  "other-fugitive-emissions",
  "purchases",
  "capital-goods",
  "water",
  "outsourcing-transport",
] as const;

export type AssetsType = (typeof assetsTypeList)[number];

export interface AssetType {
  th: string;
  en: string;
}

export interface AssetTypesResult {
  numResult: number;
  assetTypes: AssetType[];
}

export interface AssetTypeResponse {
  code: string;
  message: string;
  results: AssetTypesResult;
}
